import { CoAppDataGrid } from "../../../global/styled/global.styled";

export default function ScimWizardDataGrid(props: any) {
	const { rows, columns, apiRef, initialState, disableColumnPinning, ...rest } = props;
	return (
		<CoAppDataGrid
			{...rest}
			apiRef={apiRef}
			rows={rows}
			columns={columns}
			columnHeaderHeight={56}
			disableColumnMenu
			disableRowSelectionOnClick
			disableColumnPinning={false}
			initialState={{
				...initialState,
				pinnedColumns: { right: ["actions"] },
			}}
			hideFooter
			getRowHeight={() => "auto"}
			getEstimatedRowHeight={() => 100}
			disableVirtualization
			isscim="true"
			sx={{
				flex: 1,
				minHeight: 0,
				height: "100%",
				width: "100%",
				"& .MuiDataGrid-virtualScroller": {
					overflow: "auto",
				},
				"& .MuiDataGrid-cell": {
					display: "flex",
					alignItems: "center",
					paddingTop: "6px",
					paddingBottom: "6px",
					lineHeight: "normal",
				},
				"& .MuiDataGrid-cellContent": {
					display: "flex",
					alignItems: "center",
					width: "100%",
					minWidth: 0,
				},
				"& .MuiAutocomplete-root": {
					margin: 0,
					width: "100%",
				},
			}}
		/>
	);
}